















	import { Vue, Component, Prop } from 'vue-property-decorator';
	import LoginForm from '@/components/auth/login/LoginForm.vue';

	@Component({
		components:{
			LoginForm,
		}
	})
	export default class Login extends Vue
	{
    	$echo: any;
		public success(data: any) {
			this.$store.dispatch('auth/saveToken', data);
			this.$store.dispatch('auth/setUser', data);
			
			let locale = data.data.locale;
			
			this.$i18n.locale = locale;
			this.$store.dispatch('locale/saveLocale', locale),

			this.$echo.connector.pusher.config.auth.headers['Authorization'] = `Bearer ${data.token}`;
			
			this.$router.push({ name: 'index' });
		}
	}
